"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var AXSBlock_1 = __importDefault(require("../../layout/AXSBlock/AXSBlock"));
var rc_slider_1 = __importDefault(require("rc-slider"));
require("rc-slider/assets/index.css");
var styled_components_1 = __importDefault(require("styled-components"));
var utils_1 = require("../../utils");
var colors_1 = require("../../constants/colors");
var AXSFlex_1 = __importDefault(require("../../layout/AXSFlex"));
var classnames_1 = __importDefault(require("classnames"));
var Range = rc_slider_1.default.Range;
var StyledRange = styled_components_1.default(Range)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n .rc-slider-rail {\n    background-color: ", ";\n }\n\n  .rc-slider-track {\n    background-color: ", ";\n }\n\n .rc-slider-handle {\n  background-color: ", ";\n  border: none;\n  height: 24px;\n  margin-left: -12px;\n  margin-top: -10px;\n  width: 24px;\n\n  &:focus {\n    border-color: transparent;\n    box-shadow: none;\n  }\n }\n"], ["\n .rc-slider-rail {\n    background-color: ", ";\n }\n\n  .rc-slider-track {\n    background-color: ", ";\n }\n\n .rc-slider-handle {\n  background-color: ", ";\n  border: none;\n  height: 24px;\n  margin-left: -12px;\n  margin-top: -10px;\n  width: 24px;\n\n  &:focus {\n    border-color: transparent;\n    box-shadow: none;\n  }\n }\n"])), function (_a) {
    var railColor = _a.railColor, theme = _a.theme;
    return utils_1.parseThemePath(railColor, theme, colors_1.colors.GREY_350);
}, function (_a) {
    var trackColor = _a.trackColor, theme = _a.theme;
    return utils_1.parseThemePath(trackColor, theme, colors_1.colors.BLUE_300);
}, function (_a) {
    var handleColor = _a.handleColor, theme = _a.theme;
    return utils_1.parseThemePath(handleColor, theme, colors_1.colors.BLUE_300);
});
var Label = styled_components_1.default(AXSBlock_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var labelColor = _a.labelColor, theme = _a.theme;
    return utils_1.parseThemePath(labelColor, theme, colors_1.colors.GREY_650);
});
var Input = styled_components_1.default.input(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border: none;\n  background: transparent;\n  color: ", ";\n  text-align: ", ";\n  font-size: 15px;\n  font-weight: normal;\n  width: 120px;\n\n  &:focus {\n    outline: none;\n  }\n"], ["\n  border: none;\n  background: transparent;\n  color: ", ";\n  text-align: ", ";\n  font-size: 15px;\n  font-weight: normal;\n  width: 120px;\n\n  &:focus {\n    outline: none;\n  }\n"])), function (_a) {
    var valueColor = _a.valueColor, theme = _a.theme;
    return utils_1.parseThemePath(valueColor, theme, colors_1.colors.GREY_650);
}, function (_a) {
    var textAlign = _a.textAlign;
    return textAlign;
});
/**
 * A wrapper around https://github.com/react-component/slider/
 * with subset of it's Range functionality.
 */
var AXSRangeSlider = function (_a) {
    var className = _a.className, disabled = _a.disabled, handleChange = _a.handleChange, allowCross = _a.allowCross, value = _a.value, defaultValue = _a.defaultValue, min = _a.min, max = _a.max, step = _a.step, railColor = _a.railColor, trackColor = _a.trackColor, handleColor = _a.handleColor, labelColor = _a.labelColor, currency = _a.currency;
    var _b = React.useState(defaultValue ? defaultValue : value), range = _b[0], setRange = _b[1];
    React.useEffect(function () {
        if (value)
            setRange(value);
    });
    var updateChange = function (value) {
        // Strip out any non numerical characters such as $.
        var min = typeof value[0] === 'string' ? value[0].replace(/\D/g, '') : value[0];
        var max = typeof value[1] === 'string' ? value[1].replace(/\D/g, '') : value[1];
        handleChange([Number(min), Number(max)]);
        setRange([Number(min), Number(max)]);
    };
    var formatCurrency = function (value) {
        return new Intl.NumberFormat('en-US', {
            currency: currency,
            minimumFractionDigits: 2,
            style: 'currency',
        }).format(value);
    };
    return (React.createElement(AXSFlex_1.default, { alignItems: "center", className: classnames_1.default(['c-axs-range-slider', className]), width: "100%" },
        React.createElement(AXSBlock_1.default, { fontSize: "13px", marginRight: "24px" },
            React.createElement(Label, { labelColor: labelColor }, "Min"),
            React.createElement(AXSBlock_1.default, { border: true, borderColor: labelColor, padding: "6px" },
                React.createElement(Input, { onChange: function () { return null; }, textAlign: "left", labelColor: labelColor, readOnly: true, valueColor: labelColor, value: currency ? formatCurrency(range[0]) : range[0] }))),
        React.createElement(AXSBlock_1.default, { width: "100%", marginTop: "14px" }, value ?
            React.createElement(StyledRange, { railColor: railColor, trackColor: trackColor, handleColor: handleColor, allowCross: allowCross, disabled: disabled, max: max, min: min, onChange: updateChange, step: step, value: range }) :
            React.createElement(StyledRange, { railColor: railColor, trackColor: trackColor, handleColor: handleColor, allowCross: allowCross, disabled: disabled, max: max, min: min, onChange: updateChange, step: step, defaultValue: defaultValue })),
        React.createElement(AXSBlock_1.default, { fontSize: "13px", marginLeft: "24px" },
            React.createElement(Label, { labelColor: labelColor }, "Max"),
            React.createElement(AXSBlock_1.default, { border: true, borderColor: labelColor, padding: "6px" },
                React.createElement(Input, { onChange: function () { return null; }, labelColor: labelColor, readOnly: true, value: currency ? formatCurrency(range[1]) : range[1], valueColor: labelColor })))));
};
AXSRangeSlider.defaultProps = {
    allowCross: false,
    disabled: false,
    handleColor: 'axsui.components.rangeSlider.handleColor',
    labelColor: 'axsui.components.rangeSlider.labelColor',
    railColor: 'axsui.components.rangeSlider.railColor',
    step: 1,
    trackColor: 'axsui.components.rangeSlider.trackColor',
    valueColor: 'axsui.components.rangeSlider.valueColor',
};
exports.default = AXSRangeSlider;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map